import { createSelector } from 'reselect';
import { getIsRtpsModalEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';

export const getIsPrescreenFromBrowse = (state) => {
  return state.ApplyCardPage?.isPrescreenFromBrowse;
};

const getCheckoutUiFlagState = (state) => {
  return state.Checkout?.get('uiFlags');
};

export const getIsRtpsFlow = createSelector(
  getCheckoutUiFlagState,
  (uiFlags) => uiFlags && uiFlags?.get('isRTPSFlow')
);

export const getIsRtpsModalOpen = createSelector(
  getIsPrescreenFromBrowse,
  getIsRtpsModalEnabled,
  (isPrescreenFromBrowse, isRtpsModalEnabled) => {
    return isPrescreenFromBrowse && isRtpsModalEnabled;
  }
);
